import { Menu, MenuItem } from '@affine/component';
import {
  GlobalContextService,
  useLiveData,
  useServices,
  WorkspaceService,
} from '@toeverything/infra';
import type { PropsWithChildren } from 'react';

import {
  AffinePageReference,
  AffineSharedPageReference,
} from '../../reference-link';
import * as styles from './doc-backlinks.css';

type DocBacklinksPopupProps = PropsWithChildren<{
  backlinks: { docId: string; blockId: string; title: string }[];
}>;

export const DocBacklinksPopup = ({
  backlinks,
  children,
}: DocBacklinksPopupProps) => {
  //DNB_FIX add isSharedMode
  const { workspaceService, globalContextService } = useServices({
    WorkspaceService,
    GlobalContextService,
  });
  const isSharedMode = workspaceService.workspace.openOptions.isSharedMode;

  const docCollection = workspaceService.workspace.docCollection;

  const docMode = useLiveData(globalContextService.globalContext.docMode.$);

  const shareParams = new URLSearchParams(docMode ? { mode: docMode } : {});
  return (
    <Menu
      contentOptions={{
        className: styles.backLinksMenu,
        onClick(e) {
          e.stopPropagation();
        },
      }}
      items={
        <div className={styles.backlinksList}>
          {backlinks.map(link =>
            isSharedMode ? (
              <AffineSharedPageReference
                key={link.docId}
                pageId={link.docId}
                docCollection={docCollection}
                params={shareParams}
              />
            ) : (
              <AffinePageReference
                key={link.docId + ':' + link.blockId}
                wrapper={MenuItem}
                pageId={link.docId}
              />
            )
          )}
        </div>
      }
    >
      {children}
    </Menu>
  );
};
